import useDragAndMatchGameLoop from './useDragAndMatchGameLoop.hook';
import { StyledDragAndMatchGameLoop } from './DragAndMatchGameLoop.styled';
import DraggableText from './DraggableText/DraggableText';
import DroppableSprite from './DroppableSprite/DroppableSprite';
import DraggableContainer from './DraggableContainer/DraggableContainer';
import Sprite from '@/shared/GameComponents/GameObjects/Sprite/Sprite';
import AnswerFeedback from '../AnswerFeedback/AnswerFeedback';
import FinalScreen from './FinalScreen/FinalScreen';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
import { useContext } from 'react';

export default function DragAndMatchGameLoop({ onAnswer, onFinish }) {
  const { state, actions } = useDragAndMatchGameLoop({
    onAnswer,
    onFinish,
  });
  const game = useContext(GameLoopContext);
  return (
    <StyledDragAndMatchGameLoop
      className={game.state?.finished ? 'game-finished' : ''}
    >
      {state.gameConf.bg ? (
        <Sprite
          spriteId={state.gameConf.bg}
          transform={{
            x: 0,
            y: 0,
            width: 100,
            height: 100,
          }}
          className="user-interaction-none"
        />
      ) : null}
      <DraggableContainer
        onDragEnd={actions.onDragEnd}
        onDragStart={actions.onDragStart}
        onDragOver={actions.onDragOver}
      >
        {state.txts?.map((txt) => (
          <DraggableText
            txt={txt}
            key={`text_${txt.id}`}
            onClick={() => actions.onClick(txt)}
          />
        ))}
        {state.imgs?.map((img) => (
          <DroppableSprite
            img={img}
            key={`img_${img.id}`}
            over={game.state.currentOverId == img.id}
            isLastCorrect={game.state.lastCorrectId == img.id}
            onClick={() => actions.onClick(img)}
            className="sprite-img-droppable"
          />
        ))}
      </DraggableContainer>
      <AnswerFeedback />
      {game.state.finished ? <FinalScreen /> : null}
    </StyledDragAndMatchGameLoop>
  );
}
